// Thư mục: src/stores/driverXangDauStore.js
import { defineStore } from "pinia";
import { XangDauApi } from "@/services/xangDauService";

/**
 * Store này quản lý hành động Báo cáo Xăng dầu của tài xế
 */
export const useDriverXangDauStore = defineStore("driverXangDau", {
  state: () => ({
    isLoading: false, // Trạng thái loading khi submit
    error: null, // Lỗi khi submit
  }),
  actions: {
    /**
     * Action để tài xế submit form báo cáo đổ xăng
     * @param {object} payload - XangDauLogRequest
     * @returns {Promise<object>} XangDauLogResponse (phiếu mới)
     */
    async submitXangDauLog(payload) {
      this.isLoading = true;
      this.error = null;
      try {
        // Gọi API createLog
        const newLog = await XangDauApi.createLog(payload);
        return newLog; // Trả về log đã tạo
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi gửi báo cáo xăng dầu";
        console.error("submitXangDauLog error:", e);
        throw e; // Ném lỗi ra để component (modal) bắt
      } finally {
        this.isLoading = false;
      }
    },
  },
});
